import { t } from "i18next";
import { herobg1 } from "../assets/Images";
import { herobg2 } from "../assets/Images";
import { herobg3 } from "../assets/Images";
import { herobg4 } from "../assets/Images";
import { MdOutlineFoodBank } from "react-icons/md";

import {

  clints,
  victory,
  Hands,
  Experiance,
  IoLogoWhatsapp,
  SiFacebook,

  FaHome,
  FaInfoCircle,
  FaHandsHelping,

  IoIosCreate,
  TbCategoryFilled,
  MdCreateNewFolder,

  IoPieChartSharp,
  FaTelegram,
  FaXTwitter,

} from "../components/utils/icons";
import { FaInstagram, FaTiktok } from "react-icons/fa";

const HeroImages = [
  {
    id: 0,
    img: herobg1,
    titleAr: "أشهى أطباق اللحوم",
    titleEn: "The Finest Meat Dishes",
    subTitleAr: `سوبر مندي سبأ | تيس مندي | خروف مفطح
ربع ونصف تيس مظبي | حنيذ | مظغوط | زربيان
أشهى اللحوم بطرق الطهي اليمنية الأصيلة`,
    subTitleEn: `Saba Super Mandi | Whole Lamb Mandi | Grilled Lamb
Quarter & Half Lamb Madhbi | Haneeth | Madhghoot | Zurbian
The finest meats cooked with authentic Yemeni methods.`,
  },
  {
    id: 1,
    img: herobg2,
    titleAr: "دجاج سبأ",
    titleEn: "Saba Chicken",
    subTitleAr: `دجاج مظبي | دجاج مدفون | دجاج مندي
دجاج شواية | دجاج برياني | دجاج مظغوط
طبق دجاج سبأ الشهي بلمسة يمنية فريدة`,
    subTitleEn: `Chicken Madhbi | Chicken Madfoon | Chicken Mandi
Grilled Chicken | Chicken Biryani | Chicken Madhghoot
Saba's famous chicken dishes with a unique Yemeni touch.`,
  },
  {
    id: 2,
    img: herobg3,
    titleAr: "أشهى الأطباق البحرية",
    titleEn: "The Finest Seafood",
    subTitleAr: `طبق سمك سبأ البحري | سمك صيادية
جمبري صانونة | سمك سلمون موفى
أشهى المأكولات البحرية بلمسة يمنية أصيلة`,
    subTitleEn: `Saba Seafood Platter | Sayadiya Fish
Shrimp Sanuna | Salmon Mufta
The finest seafood with an authentic Yemeni touch.`,
  },
  {
    id: 3,
    img: herobg4,
    titleAr: "حلويات سبأ الملكية",
    titleEn: "Saba Royal Desserts",
    subTitleAr: `فته ماكس سبأ | معصوب ملكي بالقشطة والعسل
كنافة نوتيلا | نفر عسل سدر جبلي
أشهى الحلويات اليمنية والفاخرة`,
    subTitleEn: `Saba Max Fattah | Royal Masoob with Cream & Honey
Nutella Kunafa | Sidr Honey Nafar
The finest Yemeni and luxury desserts.`,
  },
];
const FotterText = {
  textEn:
    "Saba for Mandi and Madhbi Restaurant - We serve the most delicious authentic Yemeni mandi and madhbi, prepared with the finest ingredients and traditional cooking methods. Our passion is to provide you with an unforgettable dining experience, whether at the restaurant or through our delivery service.",
  textAr:
    "مطاعم سبأ للمندي والمظبي - نقدم لكم أشهى المندي والمظبي اليمني الأصيل، المحضر من أفضل المكونات وبطرق الطهي التقليدية. شغفنا هو تقديم تجربة طعام لا تُنسى لكم، سواء في المطعم أو عبر خدمة التوصيل.",
};

const navItems = [
  {
    id: 1,
    titleEn: "Home",
    titleAr: "الرئيسية",
    link: "/",
    icon: <FaHome />,
  },
  {
    id: 2,
    titleEn: "About Us",
    titleAr: "من نحن",
    link: "/AboutUs",
    icon: <FaInfoCircle />,
  },
  {
    id: 3,
    titleEn: "Featured Categories",
    titleAr: " الأصناف المميزة",
    link: "/AllFeaturedMeals",
    icon: <FaHandsHelping />,
  },

  {
    id: 4,
    titleEn: "categories",
    titleAr: "الاصناف",
    link: "/MealsCategories",
    icon: <TbCategoryFilled />,
  },
  {
    id: 5,
    titleEn: "Meals",
    titleAr: "الوجبات",
    link: "/AllResturentMeals",
    icon: <MdOutlineFoodBank />,
  },
];
const countUpData = [
  {
    id: 1,
    titleEn: "Closed Cases",
    titleAr: "قضايا مغلقة",
    count: 201560,
    icon: victory,
  },
  {
    id: 2,
    titleEn: "Clients",
    titleAr: "عملاء",
    count: 300000,
    icon: clints,
  },
  {
    id: 3,
    titleEn: "Years Experience",
    titleAr: "سنوات الخبرة",
    count: 40,
    icon: Experiance,
  },
  {
    id: 4,
    titleEn: "Lawyers",
    titleAr: "محامين",
    count: 15,
    icon: Hands,
  },
];
const socialMedia = [
  {
    id: 1,
    titleAr: "فيسبوك",
    titleEn: "Facebook",
    icon: <SiFacebook />,
    link: "https://facebook.com/share/19EXpG1Uwb/",
  },
  {
    id: 2,
    titleAr: "واتس أب",
    titleEn: "WhatsApp",
    icon: <IoLogoWhatsapp />,
    link: "https://wa.me/201515888773",
  },
  {
    id: 3,
    titleAr: "إنستجرام",
    titleEn: "Instagram",
    icon: <FaInstagram/>,
    link: "https://www.instagram.com/sabarestaurant00?stkn=ZmRqYnNwOHBlNW9i",
  },
  {
    id: 3,
    titleAr: "تيك توك",
    titleEn: "TikTok",
    icon: <FaTiktok />,
    link: "https://www.tiktok.com/@sabarestaurant.eg?_r=1&_t=ZS-99VH5aRPKhp",
  },
];

const localeTextGrid = {
  columnMenuSortAsc: t('Sort Ascending'), // ترتيب تصاعدي
  columnMenuSortDesc: t('Sort Descending'), // ترتيب تنازلي
  columnMenuUnsort: t('Unsort'), // إلغاء الترتيب
  columnMenuHideColumn: t('Hide Column'), // إخفاء العمود
  columnMenuManageColumns: t('Manage Columns'), // إدارة الأعمدة
  columnsPanelTextFieldLabel: t('Find column'), // البحث عن عمود
  columnsPanelTextFieldPlaceholder: t('Column title'), // عنوان العمود
  columnsPanelShowAllButton: t('Show all'), // عرض الكل
  columnsPanelHideAllButton: t('Hide all'), // إخفاء الكل
  columnsManagementReset: t('Reset'), // إعادة تعيين
  columnsManagementSearchTitle: t('Search'), // ترجمة كلمة "Search"

};


const AdminLinks = [
  {
    title: "Dashboard",
    links: [
      {
        name: "Dashboard",
        icon: <IoPieChartSharp />,
        linkSide: "admin",
      },
    ],
  },
  {
    title: "Meals",
    links: [ 
      {
        name: "Create Category",
        icon: <MdCreateNewFolder />,
        linkSide: "CreateCategoryPage",
      },
      {
        name: "Meal Categories",
        icon: <TbCategoryFilled />,
        linkSide: "DAllCategoriesPage",
      },
      {
        name: "All Meals",
        icon: <MdOutlineFoodBank />,
        linkSide: "DAllMealsPage",
      },
      {
        name: "Create Meal",
        icon: <IoIosCreate />,
        linkSide: "CreateMealPage",
      },
      {
        name: "Featured Meals",
        icon: <MdOutlineFoodBank />,
        linkSide: "DAllFeaturedMealsPage",
      },
      {
        name: "Create Featured Meal",
        icon: <IoIosCreate />,
        linkSide: "CreateFeaturedMealsPage",
      },
    
     
    ],
  },
  {
    title: "Reviews",
    links: [
      {
        name: "All Reviews",
        icon: <FaHandsHelping />,
        linkSide: "DAllReviewsPage",
      },
      {
        name: "Create Review",
        icon: <IoIosCreate />,
        linkSide: "CreateReviewPage",
      },
    ],
  },
];

const DeletButtonStyle={
  color: '#fff',
  background: 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)',
  boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)',
  border: 'none',

  borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const DeleteonMouseEnter= (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #dc2626, #b91c1c)';
}
const DeleteonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #dc2626, #b91c1c, #dc2626)';
}
const DeleteonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(185, 28, 28, 0.5)';
}
const DeleteonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(220, 38, 38, 0.5), 0 2px 4px -2px rgba(220, 38, 38, 0.5)';
}
const EditButtonStyle =
{
  color: '#fff',
  backgroundImage: 'linear-gradient(to right, #eab308, #ca8a04, #eab308)',
  boxShadow: '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)',
  border: 'none',

 borderRadius:"5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}
const EditonMouseEnter=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #eab308, #ca8a04)';
}
const EditonMouseLeave=(e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #eab308, #ca8a04, #eab308)';
}
const EditonFocus=(e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(202, 138, 4, 0.5)';
}
const EditonBlur=(e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(234, 179, 8, 0.5), 0 2px 4px -2px rgba(234, 179, 8, 0.5)';
}

const ViewButtonStyle = {
  color: '#fff',
  background: 'linear-gradient(to right, #16a34a, #15803d, #16a34a)',
  boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)',
  border: 'none',
  borderRadius: "5px",
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}

const ViewonMouseEnter = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to bottom right, #16a34a, #15803d)';
}

const ViewonMouseLeave = (e) => {
  e.currentTarget.style.background = 'linear-gradient(to right, #16a34a, #15803d, #16a34a)';
}

const ViewonFocus = (e) => {
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 4px rgba(21, 128, 61, 0.5)';
}

const ViewonBlur = (e) => {
  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(22, 163, 74, 0.5), 0 2px 4px -2px rgba(22, 163, 74, 0.5)';
}

export {
  HeroImages,
  navItems,
  countUpData,
  FotterText,
  socialMedia,


  AdminLinks,
  localeTextGrid,
  DeletButtonStyle,
  DeleteonMouseEnter,
  DeleteonMouseLeave,
  DeleteonFocus,
  DeleteonBlur,
  EditButtonStyle,
  EditonMouseEnter,
  EditonMouseLeave,
  EditonFocus,
  EditonBlur,
  ViewButtonStyle,
  ViewonMouseEnter,
  ViewonMouseLeave,
  ViewonFocus,
  ViewonBlur,

  
};
